import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Without this, React Router keeps the scroll position from the previous
// page, so opening a case study can land mid-page instead of at the top.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  // Links with a hash (like the footer's /#contact-form) handle their own
  // scrolling on the page they land on, so don't fight them here.
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
